export default "__VITE_ASSET__5IaoJZg5__"